import { render, staticRenderFns } from "./DetailPage1.vue?vue&type=template&id=10d521c6"
import script from "./DetailPage1.vue?vue&type=script&lang=js"
export * from "./DetailPage1.vue?vue&type=script&lang=js"
import style0 from "./DetailPage1.vue?vue&type=style&index=0&id=10d521c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports